import { render, staticRenderFns } from "./XiaoduSound.vue?vue&type=template&id=74349bdc&scoped=true"
import script from "./XiaoduSound.vue?vue&type=script&lang=js"
export * from "./XiaoduSound.vue?vue&type=script&lang=js"
import style0 from "./XiaoduSound.vue?vue&type=style&index=0&id=74349bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74349bdc",
  null
  
)

export default component.exports